import StoreCard from './store-card';
import Pagination from 'rc-pagination';
import { ReactNode } from 'react';
import { RenderProps } from '../../store-cards';

const PaginationItem = (page: number, type: string, element: ReactNode) => {
    switch (type) {
        case 'page': {
            return (
                <div className="pagination__item">
                    <button className="pagination__btn pagination__btn--active btn" type="button">
                        {page}
                    </button>
                </div>
            );
        }
        case 'prev':
        case 'next': {
            return null;
        }
        case 'jump-prev':
        case 'jump-next': {
            return <div className="pagination__item pagination__item--ellipsis">...</div>;
        }
    }
    return element;
};

export default function StoreList({ stores, total, page, setPage, pageSize }: RenderProps) {
    return (
        <>
            <ul className="tabs__list-desc tabs__list-desc--shops">
                <li className="tabs__desc-item">
                    <div className="shops__list">
                        {stores.map((s) => (
                            <StoreCard key={s.id} store={s} />
                        ))}
                    </div>
                </li>
            </ul>
            <div className="shops__pagination list-control">
                <div className="list-control__pagination pagination">
                    <div className="list-control__amount">
                        <p className="list-control__title">
                            Всего объектов: <span className="list-control__number">{total}</span>
                        </p>
                    </div>
                    <div className="list-control__pagination pagination">
                        <Pagination
                            className="pagination__list"
                            pageSize={pageSize}
                            current={page}
                            showLessItems
                            onChange={setPage}
                            total={total}
                            itemRender={PaginationItem}
                            showTitle={false}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
